import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supportService } from "../../services/SupportServices";
import { toast } from "react-toastify";

const SupportTicketDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchTicket = async () => {
    try {
      const response = await supportService.getSupportTicketById(id);
      if (response.status === 200 && response.data.success) {
        setTicket(response.data.data);
      } else {
        toast.error("Failed to fetch ticket details");
      }
    } catch (err) {
      toast.error("Error fetching ticket details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTicket();
  }, [id]);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleString("en-IN");
  };

  if (loading) return <p>Loading ticket details...</p>;
  if (!ticket) return <p>Ticket not found.</p>;

  return (
    <div className="container py-4">
      <div className="mb-4 d-flex justify-content-between align-items-center">
        <h2>Ticket #{ticket.ticket_id}</h2>
        <button className="btn btn-secondary" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>

      <div className="card p-4">
        <div className="mb-3">
          <strong>Subject:</strong> {ticket.subject}
        </div>
        <div className="mb-3">
          <strong>Status:</strong>{" "}
          <span className={`badge bg-${getBadgeColor(ticket.status)}`}>
            {ticket.status.replace("_", " ")}
          </span>
        </div>
        <div className="mb-3">
          <strong>Message:</strong>
          <p>{ticket.message}</p>
        </div>
        <div className="mb-3">
          <strong>User:</strong>{" "}
          <span>
            {ticket.user_id?.fullName} ({ticket.user_id?.email})
          </span>
        </div>
        <div className="mb-3">
          <strong>Created At:</strong> {formatDate(ticket.createdAt)}
        </div>
        <div className="mb-3">
          <strong>Last Updated:</strong> {formatDate(ticket.updatedAt)}
        </div>
      </div>
    </div>
  );
};

const getBadgeColor = (status) => {
  switch (status) {
    case "pending":
      return "warning";
    case "in_progress":
      return "info";
    case "on_hold":
      return "danger";
    case "resolved":
      return "success";
    case "closed":
      return "secondary";
    default:
      return "dark";
  }
};

export default SupportTicketDetails;
